module.exports = __webpack_public_path__ + "static/media/interactive-flashcards.9d67a760.png";